/* nx-motion-ui.js — полиш: мобилно меню, мрежа с кейсове, ленти, трио, магнитни CTA.
   Собственик: E. Зарежда се навсякъде (defer, след nx-motion-core.js).
   Всеки модул минава през NX.register → init в gsap.context на елемента. Връщаме cleanup,
   който оставя КРАЙНОТО състояние (стила от CSS-а) независимо от реда на revert-а в ядрото.
   Правила: само transform / opacity / CSS променливи; видимото при init не се скрива;
   reduced motion = крайното състояние (init просто не прави нищо). */
(function () {
  if (window.__nxUi) return;
  // обект, не true: помощните функции са изложени за node тестовете
  var UI = window.__nxUi = {};
  if (!window.NX || typeof NX.register !== 'function') return;

  var MAG_MAX = 6; // px — таванът на магнита

  function ready() { return !!(window.gsap && window.ScrollTrigger); }
  function fl(flags) { return flags || NX.flags || {}; }
  function vh() { return window.innerHeight || document.documentElement.clientHeight || 0; }
  function toArr(list) { return Array.prototype.slice.call(list || []); }

  /* кои елементи са под сгъвката — само те получават скрито начално състояние */
  function below(els, limit) {
    return els.filter(function (el) { return el.getBoundingClientRect().top >= limit; });
  }

  /* магнитът: отместване към курсора, пропорционално на разстоянието от центъра; векторът ≤ max */
  function pull(rect, px, py, max) {
    if (max == null) max = MAG_MAX;
    var hw = rect.width / 2 || 1, hh = rect.height / 2 || 1;
    var x = (px - (rect.left + hw)) / hw * max;
    var y = (py - (rect.top + hh)) / hh * max;
    var m = Math.sqrt(x * x + y * y);
    if (m > max) { x *= max / m; y *= max / m; }
    return { x: x, y: y };
  }
  UI.below = below;
  UI.pull = pull;


  /* ---------- 1. Мобилно меню: връзките влизат една след друга ---------- */
  NX.register('ui-menu', '#navToggle', function (tg, flags) {
    if (!fl(flags).motion || !ready()) return;
    var box = document.getElementById('navLinks');
    if (!box) return;
    var items = toArr(box.querySelectorAll(':scope > a, :scope > .nav-lang'));
    if (!items.length) return;
    var body = document.body, tw = null, open = body.classList.contains('nav-open');

    function settle() {                // крайно състояние: без инлайн стилове
      if (tw) { tw.kill(); tw = null; }
      gsap.set(items, { clearProps: 'transform,opacity,visibility' });
      box.classList.remove('nx-stg');
    }
    function play() {
      settle();
      box.classList.add('nx-stg');     // гаси CSS transition на transform — иначе „дърпа" след GSAP
      tw = gsap.fromTo(items, { yPercent: 60, autoAlpha: 0 },
        { yPercent: 0, autoAlpha: 1, duration: .27, ease: 'power3.out', stagger: .045, onComplete: settle });
    }
    // истината е body.nav-open (слага го скриптът в theme.liquid) — четем я СЛЕД неговия click handler
    function sync() {
      var now = body.classList.contains('nav-open');
      if (now === open) return;
      open = now;
      if (now) play(); else settle();  // затварянето е моментално
    }
    function onClick() { setTimeout(sync, 0); }
    tg.addEventListener('click', onClick, { passive: true });
    // Esc, фонът и клик по връзка също затварят — затова следим и самия клас
    var mo = window.MutationObserver ? new MutationObserver(sync) : null;
    if (mo) mo.observe(body, { attributes: true, attributeFilter: ['class'] });

    return function () {
      tg.removeEventListener('click', onClick);
      if (mo) mo.disconnect();
      settle();
    };
  });


  /* ---------- 2. Мрежата с кейсове: плочките се вдигат по редове, снимката „отваря прозорец" ---------- */
  NX.register('ui-case-grid', '[data-nx="case-grid"]', function (grid, flags) {
    if (!fl(flags).motion || !ready()) return;
    var tiles = toArr(grid.querySelectorAll('.cg-tile'));
    // видимите при init остават както са; скриваме само тези под сгъвката
    var wait = below(tiles, vh());
    if (!wait.length) return;
    var imgOf = function (t) { return t.querySelector('img'); };
    var imgs = wait.map(imgOf).filter(Boolean);
    var tweens = [], cuT = 0;

    wait.forEach(function (t) { t.classList.add('nx-cg-wait'); }); // преди set-а: img е без CSS transition
    gsap.set(wait, { y: 40, opacity: 0 });                        // opacity, не autoAlpha — Tab стига до плочката
    gsap.set(imgs, { scale: 1.12 });

    function open(batch) {
      batch = batch.filter(function (t) { return t.classList.contains('nx-cg-wait'); });
      if (!batch.length) return;
      var done = function () { batch.forEach(function (t) { t.classList.remove('nx-cg-run'); }); };
      batch.forEach(function (t) { t.classList.remove('nx-cg-wait'); t.classList.add('nx-cg-run'); });
      var bi = batch.map(imgOf).filter(Boolean);
      tweens.push(gsap.to(batch, { y: 0, opacity: 1, duration: .9, ease: 'power3.out', stagger: .08,
        overwrite: 'auto', clearProps: 'transform,opacity', onComplete: bi.length ? null : done }));
      // clearProps връща hover зума от nexum-case.css (.cg-tile:hover img)
      if (bi.length) tweens.push(gsap.to(bi, { scale: 1, duration: 1.15, ease: 'power3.out', stagger: .08,
        overwrite: 'auto', clearProps: 'transform', onComplete: done }));
    }

    var sts = ScrollTrigger.batch(wait, { start: 'top 92%', once: true, onEnter: open }) || [];

    // резерв: при скок (котва, много бърз скрол) — всичко над долния ръб се показва
    function catchUp() {
      var lim = vh();
      open(wait.filter(function (t) {
        return t.classList.contains('nx-cg-wait') && t.getBoundingClientRect().top < lim;
      }));
    }
    function onScroll() { clearTimeout(cuT); cuT = setTimeout(catchUp, 140); }
    function onFocus(e) { var t = e.target && e.target.closest && e.target.closest('.cg-tile'); if (t) open([t]); }
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('hashchange', catchUp);
    addEventListener('load', catchUp);
    grid.addEventListener('focusin', onFocus);

    return function () {
      clearTimeout(cuT);
      removeEventListener('scroll', onScroll);
      removeEventListener('hashchange', catchUp);
      removeEventListener('load', catchUp);
      grid.removeEventListener('focusin', onFocus);
      sts.forEach(function (s) { s.kill(); });
      tweens.forEach(function (t) { t.kill(); });
      gsap.set(wait, { clearProps: 'transform,opacity' });
      if (imgs.length) gsap.set(imgs, { clearProps: 'transform' });
      wait.forEach(function (t) { t.classList.remove('nx-cg-wait'); t.classList.remove('nx-cg-run'); });
    };
  });


  /* ---------- 3. Цветните ленти се „полагат" отляво надясно ---------- */
  /* CSS-ът (nx-motion-ui.css) ги прави scaleX(var(--nx-s,1)); тук въртим само променливите. */
  NX.register('ui-stripes', '.screen.stripes', function (sec, flags) {
    var f = fl(flags);
    if (!f.motion || !ready()) return;
    // вече в кадъра (или над него) при init → лентите остават цели
    if (sec.getBoundingClientRect().top < vh() * .92) return;
    var tl;
    if (f.desktop) {
      tl = gsap.timeline({ scrollTrigger: { trigger: sec, start: 'top 92%', end: 'top 55%', scrub: .6 } });
      tl.fromTo(sec, { '--nx-s': 0 }, { '--nx-s': 1, ease: 'power2.out', duration: 1 }, 0)
        .fromTo(sec, { '--nx-s2': 0 }, { '--nx-s2': 1, ease: 'power2.out', duration: 1 }, .3); // прасковената закъснява
    } else {
      // мобилно: без scrub — еднократно, .6 s общо
      tl = gsap.timeline({ scrollTrigger: { trigger: sec, start: 'top 92%', once: true } });
      tl.fromTo(sec, { '--nx-s': 0 }, { '--nx-s': 1, ease: 'power3.out', duration: .45 }, 0)
        .fromTo(sec, { '--nx-s2': 0 }, { '--nx-s2': 1, ease: 'power3.out', duration: .45 }, .15);
    }
    return function () {
      if (tl.scrollTrigger) tl.scrollTrigger.kill();
      tl.kill();
      sec.style.removeProperty('--nx-s');
      sec.style.removeProperty('--nx-s2');
    };
  });


  /* ---------- 4. Трите карти: от купчина върху средната към ветрилото от CSS-а ---------- */
  /* Пипаме само картите — .px родителят има CSS scroll-driven parallax на transform. */
  NX.register('ui-trio', '[data-nx="trio"]', function (box, flags) {
    if (!fl(flags).motion || !ready()) return;
    var cells = toArr(box.querySelectorAll('.trio-cell'));
    if (cells.length < 3) return;
    if (box.getBoundingClientRect().top < vh() * .85) return; // вече в кадъра → CSS позициите
    var mid = cells[1], side = [cells[0], cells[2]];
    // offsetLeft/Top идват от layout-а — не зависят от parallax transform-а на родителя
    var dx = function (i, el) { return mid.offsetLeft - el.offsetLeft; };
    var dy = function (i, el) { return mid.offsetTop - el.offsetTop; };
    var tl = gsap.timeline({ scrollTrigger: { trigger: box, start: 'top 85%', end: 'top 45%',
      scrub: .6, invalidateOnRefresh: true } });
    tl.fromTo(side, { x: dx, y: dy, rotation: function (i) { return i ? 4 : -4; } },
      { x: 0, y: 0, rotation: 0, ease: 'power2.out', duration: 1 }, 0);
    return function () {
      if (tl.scrollTrigger) tl.scrollTrigger.kill();
      tl.kill();
      gsap.set(side, { clearProps: 'transform' }); // обратно на scale(.94) / none от nexum.css
    };
  });


  /* ---------- 5. Магнитни CTA — само hero и финалния блок, само фин показалец ---------- */
  /* Отместването е в CSS translate (през --nx-mx/--nx-my), не в transform —
     така не се бие нито с .reveal, нито с hover-а translateY(-2px). */
  NX.register('ui-magnet', '.hero .btn, .cta-final .btn', function (el, flags) {
    var f = fl(flags);
    if (!f.motion || !f.fine || !ready()) return;
    var p = { x: 0, y: 0 }, rest = null;
    function paint() {
      el.style.setProperty('--nx-mx', p.x.toFixed(2) + 'px');
      el.style.setProperty('--nx-my', p.y.toFixed(2) + 'px');
    }
    var qx = gsap.quickTo(p, 'x', { duration: .3, ease: 'power3.out', onUpdate: paint });
    var qy = gsap.quickTo(p, 'y', { duration: .3, ease: 'power3.out', onUpdate: paint });
    el.classList.add('nx-mag');

    function measure() {             // покойната позиция = текущият rect минус нашето отместване
      var r = el.getBoundingClientRect();
      rest = { left: r.left - p.x, top: r.top - p.y, width: r.width, height: r.height };
    }
    function onEnter(e) { if (e.pointerType !== 'touch') measure(); }
    function onMove(e) {
      if (e.pointerType === 'touch') return;
      if (!rest) measure();
      var v = pull(rest, e.clientX, e.clientY);
      qx(v.x); qy(v.y);
    }
    function onLeave() { rest = null; qx(0); qy(0); }
    function onScroll() { rest = null; }
    el.addEventListener('pointerenter', onEnter, { passive: true });
    el.addEventListener('pointermove', onMove, { passive: true });
    el.addEventListener('pointerleave', onLeave, { passive: true });
    addEventListener('scroll', onScroll, { passive: true });

    return function () {
      el.removeEventListener('pointerenter', onEnter);
      el.removeEventListener('pointermove', onMove);
      el.removeEventListener('pointerleave', onLeave);
      removeEventListener('scroll', onScroll);
      if (qx.tween) qx.tween.kill();
      if (qy.tween) qy.tween.kill();
      el.classList.remove('nx-mag');
      el.style.removeProperty('--nx-mx');
      el.style.removeProperty('--nx-my');
    };
  });
})();
